// components/UserTable.jsx
import React from 'react';
import { FaEdit, FaCheck, FaTimes, FaCrown, FaUserShield } from 'react-icons/fa';

const UserTable = ({ users, toggleUserStatus, openEditModal }) => {
  // Función para formatear fechas
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('es-CL', options);
  };

  // Función para obtener el ícono del rol
  const getRoleIcon = (rol) => {
    switch(rol?.toLowerCase()) {
      case 'administrador':
        return <FaUserShield className="text-red-500" title="Administrador" />;
      case 'premium':
        return <FaCrown className="text-yellow-400" title="Premium" />;
      default:
        return null;
    }
  };

  return (
    <div className="overflow-x-auto rounded-lg shadow">
      <table className="min-w-full bg-zinc-800 divide-y divide-zinc-700">
        <thead>
          <tr>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Usuario
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Contacto
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Registro
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Estado
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Email Verificado
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Rol
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-700">
          {users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id} className="hover:bg-zinc-700 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10 bg-red-600 rounded-full flex items-center justify-center">
                      <span className="text-white font-bold">
                        {user.firstName?.charAt(0)}{user.lastName?.charAt(0)}
                      </span>
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-white flex items-center">
                        {user.firstName} {user.lastName}
                        {user.isPremium && (
                          <FaCrown className="text-yellow-400 ml-2" title="Usuario Premium" />
                        )}
                      </div>
                      <div className="text-sm text-gray-400">
                        {user.country}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-white">{user.email}</div>
                  <div className="text-sm text-gray-400">{user.phoneNumber || "No disponible"}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-white">{user.registerDate ? formatDate(user.registerDate) : "N/A"}</div>
                  <div className="text-sm text-gray-400">
                    {user.isExternal ? "Registro externo" : "Registro directo"}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    user.habilitado 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {user.habilitado ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    user.emailVerified 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {user.emailVerified ? 'Verificado' : 'Sin verificar'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    {getRoleIcon(user.rol)}
                    <span className="ml-1 text-sm text-white">{user.rol || 'Usuario'}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex justify-end space-x-2">
                    <button
                      onClick={() => toggleUserStatus(user)}
                      className={`p-1 rounded ${
                        user.habilitado 
                          ? 'bg-red-100 text-red-600 hover:bg-red-200' 
                          : 'bg-green-100 text-green-600 hover:bg-green-200'
                      }`}
                      title={user.habilitado ? 'Deshabilitar usuario' : 'Habilitar usuario'}
                    >
                      {user.habilitado ? <FaTimes /> : <FaCheck />}
                    </button>
                    <button 
                      onClick={() => openEditModal(user)}
                      className="p-1 rounded bg-blue-100 text-blue-600 hover:bg-blue-200"
                      title="Editar usuario"
                    >
                      <FaEdit />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="px-6 py-12 text-center text-gray-400">
                No se encontraron usuarios que coincidan con la búsqueda.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;